import { TSTitleCard } from '@/components/shared/card/Card';
import { dateToApiFormat, secondsToHours } from '@/helpers/dateHelper';
import { FC, useMemo } from 'react';
import { FiCalendar, FiClock, FiUser } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { SummaryCard } from '@/components/shared/card/SummaryCard';
import { useTodayRosterPositions } from './useTodayRoster';
import { Button } from '@/components/shared/button/Button';
import { CurrentlyRostered } from './CurrentlyRostered';
import { useCalculateShiftTime } from '@/services/rosters/useCalculateShiftTime';

export const TodaysRoster: FC = () => {
  const rosterPositions = useTodayRosterPositions();
  const calculateShiftTime = useCalculateShiftTime();

  const navigate = useNavigate();

  const { totalHours, totalStaff } = useMemo(() => {
    let totalTime: number = 0;
    let totalStaff: number = 0;

    rosterPositions?.forEach(p => {
      if (p.employeeId) {
        totalStaff++;

        totalTime += calculateShiftTime(p).actualTime;
      }
    });

    return { totalStaff, totalHours: secondsToHours(totalTime) };
  }, [rosterPositions, calculateShiftTime]);

  return (
    <TSTitleCard
      title={"Today's Roster"}
      icon={FiCalendar}
      smallContent={
        rosterPositions ? (
          <Button onClick={() => navigate(`/rosters/${dateToApiFormat(new Date())}`)}>View Roster</Button>
        ) : undefined
      }
    >
      {!rosterPositions ? (
        <p className="py-3 text-center">No roster was created for today</p>
      ) : (
        <>
          <div className="flex pb-5 border-b">
            <SummaryCard
              title={'Total Hours Rostered'}
              Icon={FiClock}
              value={`${totalHours} hour${totalHours !== 1 ? 's' : ''}`}
            />
            <SummaryCard
              title={'Total Staff Rostered'}
              Icon={FiUser}
              value={`${totalStaff} ${totalStaff !== 1 ? 'people' : 'person'}`}
            />
          </div>
          <CurrentlyRostered />
        </>
      )}
    </TSTitleCard>
  );
};
